const scope = {
    name_exists: 'Nazwa zakresu {{name}} jest już używana',
    name_with_space: 'Nazwa zakresu nie może zawierać spacji.',
};
export default scope;
